"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardRowComponent = void 0;
const vue_1 = require("vue");
const CardRenderItem_1 = require("../../cards/render/CardRenderItem");
const ICardRenderDescription_1 = require("../../cards/render/ICardRenderDescription");
const CardRenderSymbol_1 = require("../../cards/render/CardRenderSymbol");
const CardRenderer_1 = require("../../cards/render/CardRenderer");
const CardRenderer_2 = require("../../cards/render/CardRenderer");
const CardRenderItemComponent_1 = require("./CardRenderItemComponent");
const CardProductionBoxComponent_1 = require("./CardProductionBoxComponent");
const CardRenderEffectBoxComponent_1 = require("./CardRenderEffectBoxComponent");
const CardRenderCorpBoxComponent_1 = require("./CardRenderCorpBoxComponent");
const CardRenderPreludeBoxComponent_1 = require("./CardRenderPreludeBoxComponent");
const CardRenderTileComponent_1 = require("./CardRenderTileComponent");
const CardDescription_1 = require("./CardDescription");
const CardRenderSymbolComponent_1 = require("./CardRenderSymbolComponent");
const CardRenderer_3 = require("../../cards/render/CardRenderer");
exports.CardRowComponent = vue_1.default.component('CardRowComponent', {
    props: {
        componentData: {
            type: Object,
            required: true,
        },
    },
    components: {
        CardRenderSymbolComponent: CardRenderSymbolComponent_1.CardRenderSymbolComponent,
        CardRenderItemComponent: CardRenderItemComponent_1.CardRenderItemComponent,
        CardProductionBoxComponent: CardProductionBoxComponent_1.CardProductionBoxComponent,
        CardRenderEffectBoxComponent: CardRenderEffectBoxComponent_1.CardRenderEffectBoxComponent,
        CardRenderCorpBoxComponent: CardRenderCorpBoxComponent_1.CardRenderCorpBoxComponent,
        CardRenderPreludeBoxComponent: CardRenderPreludeBoxComponent_1.CardRenderPreludeBoxComponent,
        CardRenderTileComponent: CardRenderTileComponent_1.CardRenderTileComponent,
        CardDescription: CardDescription_1.CardDescription,
    },
    methods: {
        isItem: function () {
            return this.componentData instanceof CardRenderItem_1.CardRenderItem;
        },
        isSymbol: function () {
            return this.componentData instanceof CardRenderSymbol_1.CardRenderSymbol;
        },
        isProduction: function () {
            return this.componentData instanceof CardRenderer_1.CardRenderProductionBox;
        },
        isEffect: function () {
            return this.componentData instanceof CardRenderer_3.CardRenderEffect;
        },
        isDescription: function () {
            return typeof this.componentData === 'string' || this.componentData instanceof String || ICardRenderDescription_1.isIDescription(this.componentData);
        },
        isTile: function () {
            return this.componentData instanceof CardRenderer_2.CardRenderTile;
        },
        isCorpBox: function () {
            return this.componentData instanceof CardRenderer_3.CardRenderCorpBoxEffect || this.componentData instanceof CardRenderer_3.CardRenderCorpBoxAction;
        },
        corpBoxLabel: function () {
            if (this.componentData instanceof CardRenderer_3.CardRenderCorpBoxEffect) {
                return 'effect';
            }
            else if (this.componentData instanceof CardRenderer_3.CardRenderCorpBoxAction) {
                return 'action';
            }
            return 'n/a';
        },
        isPreludeBox: function () {
            return this.componentData instanceof CardRenderer_1.CardRenderPreludeBoxEffect || this.componentData instanceof CardRenderer_1.CardRenderPreludeBoxAction;
        },
        preludeBoxLabel: function () {
            if (this.componentData instanceof CardRenderer_1.CardRenderPreludeBoxEffect) {
                return 'effect';
            }
            else if (this.componentData instanceof CardRenderer_1.CardRenderPreludeBoxAction) {
                return 'action';
            }
            return 'n/a';
        },
    },
    template: ` 
        <CardRenderItemComponent v-if="isItem()" :item="componentData"/>
        <CardRenderSymbolComponent v-else-if="isSymbol()" :item="componentData" />
        <CardProductionBoxComponent v-else-if="isProduction()" :rows="componentData.rows" />
        <CardRenderEffectBoxComponent v-else-if="isEffect()" :effectData="componentData" />
        <CardRenderTileComponent v-else-if="isTile()" :item="componentData" />
        <CardDescription v-else-if="isDescription()" :item="componentData" />
        <CardRenderCorpBoxComponent v-else-if="isCorpBox()" :rows="componentData.rows" :label="corpBoxLabel()" />
        <CardRenderPreludeBoxComponent v-else-if="isPreludeBox()" :rows="componentData.rows" :label="preludeBoxLabel()" />
        <div v-else>n/a</div>
    `,
});
//# sourceMappingURL=CardRowComponent.js.map